module.exports = {"uuid":"0.30964019855038116","restaurantCode":"sushisurpriseshoreditch","items":[{"uuid":0.4980589275138756,"mealUuid":"7601fda6-5b7f-46c0-b2dc-3334abcca227","mealData":{"name":"Spicy Tuna Roll - Spicy!","categoryCode":"Rolls"},"quantity":1,"size":"Regular","selectedOptions":[],"unitPrice":6.1,"price":6.1},{"uuid":0.904194762424678,"mealUuid":"6e9d5589-daf8-4910-b947-f3c09f90cfad","mealData":{"name":"Kimchi Roll - Spicy!","categoryCode":"Rolls"},"quantity":1,"size":"Regular","selectedOptions":[],"unitPrice":4.6,"price":4.6}]}


//////////////////
// WEBPACK FOOTER
// ./api/mock-data/basket.json
// module id = 1226
// module chunks = 0